<template>
  <div>
    <h4>如果您新的功能需求，请联系客服，描述功能要求</h4>


  </div>
</template>

<script>
    export default {
        name: "Custom"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/Custom.vue